<template>
  <div class="container">
    <van-nav-bar
      :title="title"
      :right-text="rightText"
      left-arrow
      safe-area-inset-top
      z-index=9990
      fixed
      @click-right="clickRight"
      @click-left="backActionHandler">
    </van-nav-bar>
    <slot />
  </div>
</template>

<script>

export default {
  name: 'layout',
  data() {
    return {}
  },
  props: ['backAction', 'rightText'],
  computed: {
    title() {
      return this.$route.meta.title
    }
  },
  methods: {
    backActionHandler() {
      if (this.backAction && typeof (this.backAction) === 'function') {
        this.backAction()
      } else {
        this.$router.go(-1)
      }
    },
    clickRight() {
      this.$emit('click-right')
    }
  }
}
</script>

<style lang="scss" scoped>
  .container{
    padding-top: 46px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/index.vue